import React from 'react';
import { ExtraStyleType } from 'components/Common/Formik/FieldCustom/FieldCustom';
import RadioFieldCustom, {
  OptionType,
} from 'components/Common/Formik/RadioFieldCustom/RadioFieldCustom';
import TextFieldCustom from 'components/Common/Formik/TextFieldCustom/TextFieldCustom';
import { catalogRequestFormFields } from 'settings/fields/catalogRequest';

import styles from '../CatalogRequest.module.scss';

function CatalogRequestFields(): JSX.Element {
  const radioExtraStyle: ExtraStyleType = {
    container: `${styles.radioContainer} ${styles.field}`,
    fieldContainer: styles.radioFieldContainer,
    label: styles.radioFieldLabel,
  };

  const extraStyle: ExtraStyleType = {
    container: styles.field,
    fieldContainer: styles.fieldContainer,
    label: styles.fieldLabel,
  };

  return (
    <>
      {Object.entries(catalogRequestFormFields).map(([key, field]) => {
        if (key === 'civility') {
          return (
            <RadioFieldCustom
              key={key}
              label={field.label}
              name={field.name}
              options={field.options as OptionType[]}
              required={field.required}
              extraStyle={radioExtraStyle}
              autoComplete={field.autoComplete as string}
            />
          );
        }

        return (
          <TextFieldCustom
            key={key}
            label={field.label}
            name={field.name}
            required={field.required}
            extraStyle={extraStyle}
            uppercase={field.uppercase}
            validation={field.validation}
            disabled={field.disabled}
            type={field.type}
            placeholder={field.placeholder}
            autoComplete={field.autoComplete as string}
          />
        );
      })}
    </>
  );
}

export default CatalogRequestFields;
